import { useEffect, useState } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { get } from 'react-hook-form';
import type { DatovkaApiType } from '@gov-nx/api/types/databoxTypes';
import { useBoolean } from '@gov-nx/utils/common/Hooks/useBoolean';
import type { DataBoxMessageFormInputs } from './MessageFormContext.types';

export const useSender = (
	dataBoxes: DatovkaApiType[],
	form: UseFormReturn<DataBoxMessageFormInputs>
) => {
	const senderId = form.getValues('senderId');
	const isDropDownOpen = useBoolean(false);

	const [databox, setSelectedDataBox] = useState<DatovkaApiType>(
		dataBoxes.find((item) => item.datovaSchrankaId === senderId) ?? dataBoxes[0]
	);

	const onChange = (senderId: string) => {
		isDropDownOpen.setFalse();
		setSelectedDataBox(
			dataBoxes.find((item) => item.datovaSchrankaId === senderId) ??
				dataBoxes[0] ??
				null
		);
	};

	useEffect(() => {
		if (databox?.datovaSchrankaId) {
			form.setValue('senderId', databox.datovaSchrankaId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- These dependencies are correct
	}, [databox?.datovaSchrankaId]);

	const availableDataBoxes = dataBoxes.filter(
		(item) => item.stav === 'EXISTUJE' && !item.odpojeno
	);

	return {
		databox,
		isDropDownOpen,
		onChange,
		error: get(form.formState.errors, 'senderId'),
		availableDataBoxes,
	};
};
